// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageManagement-space1-VLu1x {
	margin-bottom: 6px !important;
}

.MessageManagement-space2-vM6ox {
	margin-bottom: 12px !important;
}

.MessageManagement-space3-IKsZP {
	margin-bottom: 18px !important;
}

.MessageManagement-space4-eS7sA {
	margin-bottom: 24px !important;
}

.MessageManagement-space5-y3a0s {
	margin-bottom: 30px !important;
}

.MessageManagement-space6-x_tyI {
	margin-bottom: 36px !important;
}

.MessageManagement-space7-qw1PO {
	margin-bottom: 42px !important;
}

.MessageManagement-space8-x89BH {
	margin-bottom: 48px !important;
}

.MessageManagement-spaceTop1-GU5dI {
	margin-top: 6px !important;
}

.MessageManagement-spaceTop2-joPcL {
	margin-top: 12px !important;
}

.MessageManagement-spaceTop3-mZFZl {
	margin-top: 18px !important;
}

.MessageManagement-spaceTop4-soIvv {
	margin-top: 24px !important;
}

.MessageManagement-spaceTop5-OSXpj {
	margin-top: 30px !important;
}

.MessageManagement-spaceTop6-_T0i2 {
	margin-top: 36px !important;
}

.MessageManagement-spaceTop7-f_VUX {
	margin-top: 42px !important;
}

.MessageManagement-spaceTop8-c4Uaw {
	margin-top: 48px !important;
}

.MessageManagement-noMargin-M0lkZ {
	margin: 0px !important;
}

.MessageManagement-padding1-tFjmI {
	padding-bottom: 6px !important;
}

.MessageManagement-padding2-FoYVm {
	padding-bottom: 12px !important;
}

.MessageManagement-padding3-GSaDj {
	padding-bottom: 18px !important;
}

.MessageManagement-padding4-TxaZg {
	padding-bottom: 24px !important;
}

.MessageManagement-padding5-zMA2J {
	padding-bottom: 30px !important;
}

.MessageManagement-padding6-lbGKK {
	padding-bottom: 36px !important;
}

.MessageManagement-padding7-XLIKJ {
	padding-bottom: 42px !important;
}

.MessageManagement-paddingTop1-aLnsf {
	padding-top: 6px !important;
}

.MessageManagement-paddingTop2-Dbvjj {
	padding-top: 12px !important;
}

.MessageManagement-paddingTop3-jgbD6 {
	padding-top: 18px !important;
}

.MessageManagement-paddingTop4-r4hJl {
	padding-top: 24px !important;
}

.MessageManagement-paddingTop5-AvA_V {
	padding-top: 30px !important;
}

.MessageManagement-paddingTop6-tCEsr {
	padding-top: 36px !important;
}

.MessageManagement-paddingTop7-IDGbF {
	padding-top: 42px !important;
}

.MessageManagement-noPadding-JfhxW {
	padding: 0px !important;
}

.MessageManagement-spaceMarginBottom0-kKduA {
	margin-bottom: 0;
}

.MessageManagement-textBold-xQGsP {
	font-weight: 500 !important;
}

.MessageManagement-textBolder-HlTh8 {
	font-weight: 700 !important;
}

.MessageManagement-textNormal-OYqoz {
	font-weight: normal !important;
}

/*New Design Text Colors */

.MessageManagement-textDarkBlue-uA8p0 {
	color: rgb(20, 39, 94) !important;
}

.MessageManagement-textLightBlue-FXRBQ {
	color: rgb(57, 87, 106) !important;
}

.MessageManagement-textLightSandleGreen-GoH2N {
	color: rgb(76, 86, 41) !important;
}

.MessageManagement-textLightBrown-clSkV {
	color: rgb(115, 79, 33) !important;
}

.MessageManagement-textMediumMaroon-tAlY9 {
	color: rgb(87, 37, 51) !important;
}

.MessageManagement-textBrown-BY0Q6 {
	color: rgb(160, 47, 24) !important;
}

.MessageManagement-textMaroon-OUyop {
	color: rgb(155, 49, 67) !important;
}

.MessageManagement-textDarkBrown-u4ao6 {
	color: rgb(83, 18, 16) !important;
}

.MessageManagement-textMediumBrown-Dc7gO {
	color: rgb(142, 28, 10) !important;
}

.MessageManagement-textSkyBlue-giiLB {
	color: rgb(37, 117, 141) !important;
}

.MessageManagement-textGray-MZB_3 {
	color: rgb(77, 65, 51) !important;
}

.MessageManagement-errorMessage-ScPqW {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.MessageManagement-userText-TWIVP {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.MessageManagement-panelHeader-XPd6f {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.MessageManagement-exportSection-IfWv9 {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.MessageManagement-exportSectionGridSub-TUji5 {
	grid-template-columns: 50% 49% !important;
}

.MessageManagement-exportText-rZGiG {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.MessageManagement-exportLinkImg-W7KHM {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.MessageManagement-exportImg-jFjn1 {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.MessageManagement-linkBtn-BllpK {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.MessageManagement-table-cAq6e {
	display: table;
}

.MessageManagement-tableRow-uJFv4 {
	display: table-row;
}

.MessageManagement-tableCell-dSJKp {
	display: table-cell;
	float: none;
}

.MessageManagement-formGroup-qZmYB {
	margin-bottom: 6px;
}

.MessageManagement-marginTop0-Hkpc1 {
	margin-top: 0;
}

.MessageManagement-marginBottom20-zldiY {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.MessageManagement-bannerImageBg-ACI2j {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.MessageManagement-bannerDelete-crJMd {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.MessageManagement-exportLink-amlRw {
	padding-top: 10px;
	padding-right: 10px;
}

.MessageManagement-seachContent-oM12I {
	padding-left: 0px;
	margin-bottom: 5px;
}

.MessageManagement-marginBottom9-qLjiT {
	margin-bottom: 9px;
}

.MessageManagement-spaceTop52-uyipp {
	margin-top: 52px;
}

.MessageManagement-profileViewInner-ASMb0 {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.MessageManagement-profileViewMain-5IRsY {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.MessageManagement-profileViewlabel-Zdm35 {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.MessageManagement-profileViewMainContent-CrTpk {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.MessageManagement-reviewsFormStar-r6dBZ {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.MessageManagement-reviewsFormStar-r6dBZ svg {
	cursor: pointer;
}

.MessageManagement-addLanguageText-AOn_N {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.MessageManagement-exportSection-IfWv9 {
		grid-template-columns: 100%;
	}

	.MessageManagement-spaceTop52-uyipp {
		margin-top: 18px;
	}

	.MessageManagement-exportText-rZGiG {
		float: none;
		margin-top: 12px;
	}

	.MessageManagement-exportSectionGridSub-TUji5 {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.MessageManagement-profileViewlabel-Zdm35 {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.MessageManagement-profileViewMainContent-CrTpk {
		width: 100%;
		text-align: center;
	}

	.MessageManagement-panelHeader-XPd6f {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `MessageManagement-space1-VLu1x`,
	"space2": `MessageManagement-space2-vM6ox`,
	"space3": `MessageManagement-space3-IKsZP`,
	"space4": `MessageManagement-space4-eS7sA`,
	"space5": `MessageManagement-space5-y3a0s`,
	"space6": `MessageManagement-space6-x_tyI`,
	"space7": `MessageManagement-space7-qw1PO`,
	"space8": `MessageManagement-space8-x89BH`,
	"spaceTop1": `MessageManagement-spaceTop1-GU5dI`,
	"spaceTop2": `MessageManagement-spaceTop2-joPcL`,
	"spaceTop3": `MessageManagement-spaceTop3-mZFZl`,
	"spaceTop4": `MessageManagement-spaceTop4-soIvv`,
	"spaceTop5": `MessageManagement-spaceTop5-OSXpj`,
	"spaceTop6": `MessageManagement-spaceTop6-_T0i2`,
	"spaceTop7": `MessageManagement-spaceTop7-f_VUX`,
	"spaceTop8": `MessageManagement-spaceTop8-c4Uaw`,
	"noMargin": `MessageManagement-noMargin-M0lkZ`,
	"padding1": `MessageManagement-padding1-tFjmI`,
	"padding2": `MessageManagement-padding2-FoYVm`,
	"padding3": `MessageManagement-padding3-GSaDj`,
	"padding4": `MessageManagement-padding4-TxaZg`,
	"padding5": `MessageManagement-padding5-zMA2J`,
	"padding6": `MessageManagement-padding6-lbGKK`,
	"padding7": `MessageManagement-padding7-XLIKJ`,
	"paddingTop1": `MessageManagement-paddingTop1-aLnsf`,
	"paddingTop2": `MessageManagement-paddingTop2-Dbvjj`,
	"paddingTop3": `MessageManagement-paddingTop3-jgbD6`,
	"paddingTop4": `MessageManagement-paddingTop4-r4hJl`,
	"paddingTop5": `MessageManagement-paddingTop5-AvA_V`,
	"paddingTop6": `MessageManagement-paddingTop6-tCEsr`,
	"paddingTop7": `MessageManagement-paddingTop7-IDGbF`,
	"noPadding": `MessageManagement-noPadding-JfhxW`,
	"spaceMarginBottom0": `MessageManagement-spaceMarginBottom0-kKduA`,
	"textBold": `MessageManagement-textBold-xQGsP`,
	"textBolder": `MessageManagement-textBolder-HlTh8`,
	"textNormal": `MessageManagement-textNormal-OYqoz`,
	"textDarkBlue": `MessageManagement-textDarkBlue-uA8p0`,
	"textLightBlue": `MessageManagement-textLightBlue-FXRBQ`,
	"textLightSandleGreen": `MessageManagement-textLightSandleGreen-GoH2N`,
	"textLightBrown": `MessageManagement-textLightBrown-clSkV`,
	"textMediumMaroon": `MessageManagement-textMediumMaroon-tAlY9`,
	"textBrown": `MessageManagement-textBrown-BY0Q6`,
	"textMaroon": `MessageManagement-textMaroon-OUyop`,
	"textDarkBrown": `MessageManagement-textDarkBrown-u4ao6`,
	"textMediumBrown": `MessageManagement-textMediumBrown-Dc7gO`,
	"textSkyBlue": `MessageManagement-textSkyBlue-giiLB`,
	"textGray": `MessageManagement-textGray-MZB_3`,
	"errorMessage": `MessageManagement-errorMessage-ScPqW`,
	"userText": `MessageManagement-userText-TWIVP`,
	"panelHeader": `MessageManagement-panelHeader-XPd6f`,
	"exportSection": `MessageManagement-exportSection-IfWv9`,
	"exportSectionGridSub": `MessageManagement-exportSectionGridSub-TUji5`,
	"exportText": `MessageManagement-exportText-rZGiG`,
	"exportLinkImg": `MessageManagement-exportLinkImg-W7KHM`,
	"exportImg": `MessageManagement-exportImg-jFjn1`,
	"linkBtn": `MessageManagement-linkBtn-BllpK`,
	"table": `MessageManagement-table-cAq6e`,
	"tableRow": `MessageManagement-tableRow-uJFv4`,
	"tableCell": `MessageManagement-tableCell-dSJKp`,
	"formGroup": `MessageManagement-formGroup-qZmYB`,
	"marginTop0": `MessageManagement-marginTop0-Hkpc1`,
	"marginBottom20": `MessageManagement-marginBottom20-zldiY`,
	"bannerImageBg": `MessageManagement-bannerImageBg-ACI2j`,
	"bannerDelete": `MessageManagement-bannerDelete-crJMd`,
	"exportLink": `MessageManagement-exportLink-amlRw`,
	"seachContent": `MessageManagement-seachContent-oM12I`,
	"marginBottom9": `MessageManagement-marginBottom9-qLjiT`,
	"spaceTop52": `MessageManagement-spaceTop52-uyipp`,
	"profileViewInner": `MessageManagement-profileViewInner-ASMb0`,
	"profileViewMain": `MessageManagement-profileViewMain-5IRsY`,
	"profileViewlabel": `MessageManagement-profileViewlabel-Zdm35`,
	"profileViewMainContent": `MessageManagement-profileViewMainContent-CrTpk`,
	"reviewsFormStar": `MessageManagement-reviewsFormStar-r6dBZ`,
	"addLanguageText": `MessageManagement-addLanguageText-AOn_N`
};
module.exports = ___CSS_LOADER_EXPORT___;
